import React from 'react';
import './Projects.css';

const Projects = () => {
  return (
    <section className="projects-section">
      <h1>My Projects</h1>

      <div className="project-grid">

        {/*  CastMe  */}
        <a
          href="https://github.com/wjurasz/CastMe"
          target="_blank"
          rel="noopener noreferrer"
          className="project-link"
        >
          <div className="project-card">
            <img
              src={`${process.env.PUBLIC_URL}/Icons/CastMepng.png`}
              alt="CastMe"
              className="project-image"
            />
            <div className="project-description">
              <h3>CastMe</h3>
              <p>
                CastMe is a web application designed to bring all castings together in one place.<br />
                The platform connects models, volunteers, and photographers who are looking for casting opportunities.
              </p>
            </div>
          </div>
        </a>

        {/*  HotelApp */}
        <a
          href="https://github.com/wjurasz/HotelApp"
          target="_blank"
          rel="noopener noreferrer"
          className="project-link"
        >
          <div className="project-card">
            <img
              src={`${process.env.PUBLIC_URL}/Icons/front hotelapi.png`}
              alt="Hotel App"
              className="project-image"
            />
            <div className="project-description">
              <h3>HotelApp</h3>
              <p>
                Hotel booking app with search, filters, and smooth UX.<br />
                Backend in C# (REST API), frontend in React.js.
              </p>
            </div>
          </div>
        </a>

        {/*ChatAI */}
        <a
          href="https://github.com/wjurasz/ChatAI"
          target="_blank"
          rel="noopener noreferrer"
          className="project-link"
        >
          <div className="project-card">
            <img
              src={`${process.env.PUBLIC_URL}/Icons/chatAI.png`}
              alt="ChatAI"
              className="project-image"
            />
            <div className="project-description">
              <h3>ChatAI</h3>
              <p>
                Blazor app with user login, real-time weather search via API, and an AI chat powered by the LLaMA language model.
              </p>
            </div>
          </div>
        </a>

        {/*DTA*/}
        <a
          href="https://github.com/wjurasz/DesignThinkingApp"
          target="_blank"
          rel="noopener noreferrer"
          className="project-link"
        >
          <div className="project-card">
            <img
              src={`${process.env.PUBLIC_URL}/Icons/strg.png`}
              alt="Design Thinking App"
              className="project-image"
            />
            <div className="project-description">
              <h3>Design Thinking App</h3>
              <p>
                Fullstack web app for managing projects using the Design Thinking methodology, with task and idea management for team collaboration.
              </p>
            </div>
          </div>
        </a>
      </div>
    </section>
  );
};

export default Projects;
